import React from "react";
import * as Icons from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { fmtDateTime } from "./docConstants";

const KIND_LABEL = { client: "Client / family", external: "Partner / vendor", professional: "Professional" };
const STATUS_LABEL = { sent: "Sent", delivered: "Sent", queued: "Queued", failed: "Failed", in_app_only: "In-app only" };

const relLabel = (iso) => {
  if (!iso) return "";
  const then = new Date(iso), now = new Date();
  const days = Math.floor((now.setHours(0, 0, 0, 0) - new Date(iso).setHours(0, 0, 0, 0)) / 86400000);
  if (days <= 0) return "Reminded today";
  if (days === 1) return "Reminded yesterday";
  if (days < 7) return `Reminded ${days}d ago`;
  return `Last reminded ${then.toLocaleDateString(undefined, { month: "short", day: "numeric" })}`;
};

// PROMPT 13H — tiny staff-only "Last Reminded" chip for the Document Review queue.
export default function LastRemindedChip({ reminder, docId }) {
  if (!reminder || !reminder.last_at) return null;
  const failed = reminder.delivery_status === "failed";
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          data-testid={`last-reminded-chip-${docId}`}
          className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10.5px] font-semibold cursor-default ${failed ? "bg-[#FDECEC] text-[#9C1E22]" : "bg-[#F3F0FB] text-[#7C3AED]"}`}
        >
          <Icons.BellRing size={10} />
          {relLabel(reminder.last_at)}
          {reminder.count > 1 && <span className="opacity-70">×{reminder.count}</span>}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[240px]" data-testid={`last-reminded-tip-${docId}`}>
        <div className="text-[12px] space-y-0.5">
          <div className="font-semibold">{reminder.recipient_name} <span className="font-normal opacity-80">({KIND_LABEL[reminder.recipient_kind] || reminder.recipient_kind})</span></div>
          {reminder.recipient_email && <div className="opacity-80">{reminder.recipient_email}</div>}
          <div className="opacity-80">Status: {STATUS_LABEL[reminder.delivery_status] || reminder.delivery_status}</div>
          <div className="opacity-80">{fmtDateTime(reminder.last_at)} · by {reminder.sent_by}</div>
          {reminder.count > 1 && <div className="opacity-70">{reminder.count} reminders total</div>}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
